import type { EventRecord } from '@vlabs/api/artemy/model';

import type { MapMarker } from './types';

export function getMarkerPoint3(
  event?: Pick<EventRecord, 'event_id' | 'location'>,
): MapMarker | null {
  if (!event?.event_id || !event.location?.geo_position) {
    return null;
  }

  return {
    id: event.event_id,
    position: [
      event.location.geo_position.latitude,
      event.location.geo_position.longitude,
    ],
  };
}
